/* Tiba Salud — Motor de recompensas del carrito (reemplaza a EasyGift).
 *
 * Reglas: <script id="tiba-reward-rules"> (snippets/reward-rules-json.liquid, Theme settings > Recompensas).
 *
 * En cada cambio de carrito:
 *   1. subtotal elegible = suma de líneas de COMPRA ÚNICA que no son regalo
 *      (las suscripciones no cuentan; el precio del regalo tampoco).
 *   2. nivel objetivo = el nivel más alto disponible cuyo mínimo <= subtotal.
 *   3. UNA sola petición POST /cart/update.js que en el mismo `updates` quita los regalos
 *      que sobran (key de línea -> 0), deja el objetivo en cantidad 1 y lo agrega si falta
 *      (variant_id -> 1). En esa misma respuesta pide `sections` y con eso re-renderiza.
 *   4. si el nivel objetivo está agotado (422/404) lo marca y reintenta con el siguiente.
 *
 * El precio $0 del regalo NO lo pone este script: lo da el descuento automático
 * "Compra X y llévate Y" de Shopify (uno por nivel). Aquí solo se decide qué va en el carrito.
 *
 * Los regalos se identifican SOLO por variant_id / product_id de las reglas: ya no se usa
 * ninguna propiedad de línea, porque Shopify trata propiedades distintas como líneas
 * distintas y eso provocaba regalos duplicados al cambiar cantidades.
 *
 * Robustez: un solo ciclo a la vez, máximo 3 pasadas por ciclo, timeout de 15 s por
 * petición, estado de carga visible antes de la red, y si la petición falla no se
 * re-renderiza (se deja el DOM del theme y se reintenta en el siguiente evento).
 */
(function () {
  'use strict';

  var SOLDOUT_KEY = 'tiba_reward_soldout';
  var SOLDOUT_TTL = 10 * 60 * 1000;
  var MAX_PASSES = 3;
  var DEBOUNCE_MS = 250;
  var TIMEOUT_MS = 15000;
  var BUSY_CLASS = 'reward-engine--busy';
  var HOST_IDS = ['Cart-Drawer', 'Cart'];

  var rules = readRules();
  if (!rules || !rules.gifts.length) return;

  var giftProductIds = {};
  var giftVariantIds = {};
  rules.gifts.forEach(function (g) {
    giftProductIds[String(g.product_id)] = g;
    giftVariantIds[String(g.variant_id)] = g;
  });

  var inFlight = false;
  var pending = false;
  var seedCart = null;
  var timer = null;

  function warn(e) {
    if (window.console && window.console.warn) window.console.warn('[reward-engine]', e);
  }

  function readRules() {
    var el = document.getElementById('tiba-reward-rules');
    if (!el) return null;
    try {
      var data = JSON.parse(el.textContent);
      if (!data || !Array.isArray(data.gifts)) return null;
      data.gifts = data.gifts
        .filter(function (g) { return g && g.variant_id && g.product_id && g.min > 0; })
        .sort(function (a, b) { return a.min - b.min; });
      return data;
    } catch (e) {
      return null;
    }
  }

  /* --- rutas (con respaldo si el theme no publicó theme.routes) --- */
  function routes() {
    var r = {};
    try {
      if (typeof theme !== 'undefined' && theme && theme.routes) r = theme.routes;
    } catch (e) { /* theme no definido */ }
    return {
      cart: r.cart_url || '/cart',
      update: r.cart_update_url || '/cart/update'
    };
  }

  /* --- agotados en esta sesión (422 al agregar) --- */
  function soldoutMap() {
    try {
      var raw = sessionStorage.getItem(SOLDOUT_KEY);
      var map = raw ? JSON.parse(raw) : {};
      var now = Date.now();
      Object.keys(map).forEach(function (k) { if (map[k] < now) delete map[k]; });
      return map;
    } catch (e) { return {}; }
  }
  function markSoldout(variantId) {
    try {
      var map = soldoutMap();
      map[String(variantId)] = Date.now() + SOLDOUT_TTL;
      sessionStorage.setItem(SOLDOUT_KEY, JSON.stringify(map));
    } catch (e) { /* modo privado */ }
  }

  /* --- lógica pura (mismo criterio que reward-progress.liquid / reward-cart-state.liquid) --- */
  function isGiftItem(item) {
    if (giftProductIds[String(item.product_id)]) return true;
    if (giftVariantIds[String(item.variant_id)]) return true;
    return false;
  }
  function isSubscription(item) {
    return !!item.selling_plan_allocation;
  }
  function eligibleSubtotal(cart) {
    var cents = 0;
    if (!cart || !cart.items) return 0;
    cart.items.forEach(function (item) {
      if (isGiftItem(item) || isSubscription(item)) return;
      cents += item.final_line_price;
    });
    return cents / 100;
  }
  function targetGift(subtotal) {
    var soldout = soldoutMap();
    var target = null;
    rules.gifts.forEach(function (g) {
      if (g.available === false) return;
      if (soldout[String(g.variant_id)]) return;
      if (subtotal < g.min) return;
      if (g.max != null && subtotal >= g.max) return; // rango con tope (viene del servicio)
      target = g; // ordenados por min ascendente: gana el más alto
    });
    return target;
  }

  /* --- red --- */
  function withTimeout(url, init) {
    init = init || {};
    var ctrl = null;
    var t = null;
    if (typeof AbortController === 'function') {
      try {
        ctrl = new AbortController();
        init.signal = ctrl.signal;
        t = setTimeout(function () { try { ctrl.abort(); } catch (e) { /* ya terminó */ } }, TIMEOUT_MS);
      } catch (e) { ctrl = null; }
    }
    function done(v) { if (t) clearTimeout(t); return v; }
    return fetch(url, init).then(done, function (e) { done(); throw e; });
  }
  function getCart() {
    return withTimeout(routes().cart + '.js', {
      headers: { 'Accept': 'application/json' },
      cache: 'no-store'
    }).then(function (r) { return r.json(); });
  }

  /* Secciones a re-renderizar: solo las que están en el DOM de esta página. */
  function sectionsToRender() {
    return [
      { id: 'Cart', section: 'main-cart', selector: '.thb-cart-form' },
      { id: 'Cart-Drawer', section: 'cart-drawer', selector: '.cart-drawer' },
      { id: 'cart-drawer-toggle', section: 'cart-bubble', selector: '.thb-item-count' }
    ].filter(function (s) { return !!document.getElementById(s.id); });
  }

  /* Diferencias entre el carrito y el objetivo, en un solo objeto `updates`.
   * Devuelve null si no hay nada que cambiar. */
  function planUpdates(cart) {
    var target = targetGift(eligibleSubtotal(cart));
    var updates = {};
    var removeKeys = [];
    var keepKey = null;
    var changed = false;
    var adding = false;

    (cart && cart.items ? cart.items : []).forEach(function (item) {
      if (!isGiftItem(item)) return;
      var isTarget = target && String(item.variant_id) === String(target.variant_id);
      if (!isTarget) {
        updates[item.key] = 0;
        removeKeys.push(item.key);
        changed = true;
        return;
      }
      if (keepKey === null) {
        // Se conserva por key de línea (no por variant_id) para no ser ambiguo
        // si quedan líneas viejas del mismo producto con propiedades.
        keepKey = item.key;
        if (item.quantity !== 1) {
          updates[item.key] = 1;
          changed = true;
        }
      } else {
        updates[item.key] = 0; // duplicado
        removeKeys.push(item.key);
        changed = true;
      }
    });

    if (target && keepKey === null) {
      updates[String(target.variant_id)] = 1; // variant_id que no está en el carrito => lo agrega
      changed = true;
      adding = true;
    }

    if (!changed) return null;
    return { updates: updates, removeKeys: removeKeys, target: target, adding: adding };
  }

  /* Una sola petición: quita, ajusta, agrega y trae el HTML de las secciones. */
  function applyUpdates(plan, wanted) {
    var body = { updates: plan.updates };
    if (wanted.length) {
      body.sections = wanted.map(function (s) { return s.section; }).join(',');
      body.sections_url = window.location.pathname;
    }
    return withTimeout(routes().update + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    }).then(function (r) {
      // 422: sin inventario. 404: la variante ya no existe en el canal.
      if (r.status === 422 || r.status === 404) {
        if (plan.adding && plan.target) {
          markSoldout(plan.target.variant_id);
          return { ok: false, retry: true };
        }
        return { ok: false, retry: false };
      }
      if (!r.ok) return { ok: false, retry: false };
      return r.json().then(function (cart) { return { ok: true, cart: cart }; });
    });
  }

  /* --- estado de carga (antes de tocar la red) --- */
  function eachHost(fn) {
    HOST_IDS.forEach(function (id) {
      var el = document.getElementById(id);
      if (el && el.classList) fn(el);
    });
  }
  function lineNodes(key) {
    if (!document.querySelectorAll) return [];
    var safe = String(key).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
    try {
      var list = document.querySelectorAll('[data-line-key="' + safe + '"], [data-product-id="' + safe + '"]');
      return Array.prototype.slice.call(list);
    } catch (e) { return []; }
  }
  function markBusy(plan) {
    try {
      eachHost(function (el) { el.classList.add(BUSY_CLASS); });
      plan.removeKeys.forEach(function (key) {
        lineNodes(key).forEach(function (n) {
          if (n.classList) n.classList.add('thb-loading');
          if (n.setAttribute) n.setAttribute('aria-busy', 'true');
        });
      });
    } catch (e) { warn(e); }
  }
  function clearBusy() {
    try {
      eachHost(function (el) { el.classList.remove(BUSY_CLASS); });
    } catch (e) { /* el nodo pudo desaparecer con el re-render */ }
  }

  /* --- re-render de secciones (mismo mecanismo que app.js) --- */
  function sectionInnerHTML(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var node = doc.querySelector(selector);
    return node ? node.innerHTML : null;
  }
  function applySections(sections, wanted) {
    wanted.forEach(function (s) {
      if (!sections[s.section]) return;
      var host = document.getElementById(s.id);
      if (!host) return;
      var el = host.querySelector(s.selector) || host;
      var html = sectionInnerHTML(sections[s.section], s.selector);
      if (html !== null) el.innerHTML = html;
    });
  }
  function afterRender(cart) {
    try {
      if (typeof CartDrawer !== 'undefined' && document.getElementById('Cart-Drawer')) new CartDrawer();
      if (typeof Cart !== 'undefined' && document.getElementById('Cart')) new Cart();
    } catch (e) { warn(e); }
    try {
      if (typeof dispatchCustomEvent === 'function') {
        dispatchCustomEvent('line-item:change:end', { cart: cart, source: 'reward-engine' });
      }
      document.dispatchEvent(new CustomEvent('reward-engine:updated', { detail: { cart: cart, source: 'reward-engine' } }));
    } catch (e) { warn(e); }
  }
  /* Respaldo: si la respuesta no trajo `sections` (theme viejo o sections_url inválido). */
  function refetchSections(cart, wanted) {
    if (!wanted.length) { afterRender(cart); return Promise.resolve(); }
    var names = wanted.map(function (s) { return s.section; }).join(',');
    var path = window.location.pathname;
    var url = path + (path.indexOf('?') >= 0 ? '&' : '?') + 'sections=' + names;
    return withTimeout(url, { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        applySections(sections || {}, wanted);
        afterRender(cart);
      })
      .catch(function (e) { warn(e); });
  }
  function render(cart, wanted) {
    if (cart && cart.sections) {
      applySections(cart.sections, wanted);
      afterRender(cart);
      return Promise.resolve();
    }
    return refetchSections(cart, wanted);
  }

  /* --- ciclo --- */
  function run(cart) {
    if (inFlight) { pending = true; return; }
    inFlight = true;
    var passes = 0;

    function done() {
      clearBusy();
      inFlight = false;
      if (pending) { pending = false; schedule(null); }
    }

    function step(known) {
      var first = known && known.items ? Promise.resolve(known) : getCart();
      return first.then(function (current) {
        if (passes >= MAX_PASSES) return null;
        passes++;
        var plan = planUpdates(current);
        if (!plan) return null;
        var wanted = sectionsToRender();
        markBusy(plan);
        return applyUpdates(plan, wanted).then(function (result) {
          if (result.ok) return render(result.cart, wanted);
          if (result.retry) return step(null); // nivel agotado: reintenta con el siguiente
          return null; // falló la red: no se re-renderiza, se reintenta al próximo evento
        });
      });
    }

    try {
      step(cart).catch(function (e) { warn(e); }).then(done, done);
    } catch (e) {
      warn(e);
      done();
    }
  }

  function schedule(cart) {
    seedCart = cart && cart.items ? cart : null;
    clearTimeout(timer);
    timer = setTimeout(function () {
      var c = seedCart;
      seedCart = null;
      run(c);
    }, DEBOUNCE_MS);
  }

  /* `line-item:change:end` ya trae el carrito completo (respuesta de /cart/change.js):
   * se usa tal cual y así no hace falta un GET /cart.js extra. */
  function onThemeEvent(evt) {
    if (evt && evt.detail && evt.detail.source === 'reward-engine') return;
    var cart = evt && evt.detail ? evt.detail.cart : null;
    schedule(cart);
  }

  ['cart:item-added', 'line-item:change:end', 'cart-drawer:open', 'cart:refresh'].forEach(function (name) {
    document.addEventListener(name, onThemeEvent);
  });
  window.addEventListener('pageshow', function (e) { if (e && e.persisted) schedule(null); });
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) schedule(null);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { schedule(null); });
  } else {
    schedule(null);
  }

  window.TibaRewardEngine = {
    run: schedule,
    rules: rules,
    eligibleSubtotal: eligibleSubtotal,
    targetGift: targetGift,
    planUpdates: planUpdates
  };
})();
